import axios from 'axios';
import { setupAuthInterceptor } from '../common';
import { NAMESPACES } from '../configuration';
const BASE_URL = NAMESPACES.users_api.user_invitations;

// Helper function to configure the Axios instance
const api = setupAuthInterceptor(axios.create({
    baseURL: BASE_URL,
    headers: {
      'Content-Type': 'application/json'
    }
  }));

  export const getAllUserInvitations = async () => {
    return await api.get('/GetAllUserInvitations');
  };


  export const getUserInvitationsByLocalId = async (localId: number) => {
    return await api.get(`/GetUserInvitationsByLocalId/${localId}`);
  };


  export const reactivateUserInvitation = async (invitation_id: number) => {
    return await api.get(`/ReactivateUserInvitation/${invitation_id}`);
  };

  
  export const validateUserInvitation = async (invitationId: number) => {
    return await api.get(`/ValidateUserInvitation/${invitationId}`);
  };
  

  export const createUserInvitation = async (invitationData: any) => {
    return await api.post('/CreateUserInvitation', invitationData);
  };

  
  export const createUserFromInvitation = async (userData: any) => {
    return await api.post('/CreateUserFromInvitation', userData);
  };


  export const deleteUserInvitation = async (invitation_id: number) => {
    return await api.delete(`/DeleteUserInvitation/${invitation_id}`);
  };